type HelpImagePoint = {
    id: number | string;
    x: number;
    y: number;
};

export function initHelpImageMap(root: HTMLElement): void {
    document.body.classList.add('system-help-image-map-page');

    const pointsJson = root.dataset.points ?? '[]';
    let points: HelpImagePoint[] = [];

    try {
        points = JSON.parse(pointsJson) as HelpImagePoint[];
    } catch {
        points = [];
    }

    const positionIcons = () => {
        const image = document.querySelector<HTMLImageElement>('.img-background');

        if (!image) {
            return;
        }

        points.forEach((point) => {
            const element = document.getElementById(`info-icon-${point.id}`);

            if (!element || !image.naturalWidth) {
                return;
            }

            const x = image.clientWidth / image.naturalWidth * point.x;
            const y = image.clientHeight / image.naturalHeight * point.y;
            element.style.left = `${x}px`;
            element.style.top = `${y}px`;
            element.classList.add('system-help-image-map__icon');
        });
    };

    const image = document.querySelector<HTMLImageElement>('.img-background');
    const timeout = image && image.naturalWidth === 0 ? 1000 : 0;

    window.setTimeout(positionIcons, timeout);

    $(document).ready(() => {
        $('div.img-overlay-wrap').parent().on('click', (event) => {
            const target = event.target as HTMLElement;

            if (target.nodeName === 'BODY') {
                parent.jQuery.fancybox.close();
            }
        });
    });

    root.querySelectorAll<HTMLElement>('[data-page-not-found]').forEach((element) => {
        element.addEventListener('click', () => {
            alert(element.dataset.pageNotFound ?? '');
        });
    });
}
